module.exports = "/fonts/fa-solid-900.woff2?8a8c0474283e0d9ef41743e5e486bf05";